import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "filters",
  id: "filter-tab-external-content"
}
const _hoisted_2 = { class: "filter-group" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon",
  focusable: "false",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#arrow-white" })
], -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "dealersSortDescending" }, "Dealership", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All airports", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All countries", -1 /* HOISTED */)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "filter-group" }
const _hoisted_11 = { class: "mobileSingleButton" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "dealersSelectDiamond",
  "aria-label": "Diamond"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "svg-icon svg-icon-2x",
    focusable: "false",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#diamond-icon-white" })
  ])
], -1 /* HOISTED */)
const _hoisted_13 = { class: "mobileSingleButton" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "dealersSelectMap",
  "aria-label": "Select Map"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "svg-icon svg-icon-2x",
    focusable: "false",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#map-icon-white" })
  ])
], -1 /* HOISTED */)
const _hoisted_16 = { class: "search-div" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon text-black",
  focusable: "false",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#search" })
], -1 /* HOISTED */)
const _hoisted_18 = {
  key: 0,
  class: "list-view"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "letter-group" }
const _hoisted_21 = { class: "letter" }
const _hoisted_22 = ["onClick", "innerHTML"]
const _hoisted_23 = {
  key: 0,
  class: "svg-icon",
  focusable: "false",
  role: "img"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#diamond-icon-blue" }, null, -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.selectMap == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortDescending) = $event)),
                id: "dealersSortDescending",
                class: "form-check-input",
                onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.updateFilters()))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelCheckbox, _ctx.sortDescending]
              ]),
              _hoisted_4,
              _hoisted_5
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedAirport) = $event)),
            id: "dealersSelectedAirport",
            class: "form-control form-select",
            onChange: _cache[3] || (_cache[3] = ($event: any) => ($options.updateFilters()))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.airports, (airport) => {
              return (_openBlock(), _createElementBlock("option", {
                value: airport.code
              }, _toDisplayString(airport.code), 9 /* TEXT, PROPS */, _hoisted_7))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedAirport]
          ])
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCountry) = $event)),
            id: "dealersSelectedCountry",
            class: "form-control form-select",
            onChange: _cache[5] || (_cache[5] = ($event: any) => ($options.updateFilters()))
          }, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
              return (_openBlock(), _createElementBlock("option", {
                value: country.code
              }, _toDisplayString(country.name), 9 /* TEXT, PROPS */, _hoisted_9))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedCountry]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectDiamond) = $event)),
            id: "dealersSelectDiamond",
            class: "form-check-input",
            onChange: _cache[7] || (_cache[7] = ($event: any) => ($options.updateFilters()))
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelCheckbox, _ctx.selectDiamond]
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            disabled: $options.disableMapButton,
            type: "checkbox",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectMap) = $event)),
            id: "dealersSelectMap",
            class: "form-check-input",
            onChange: _cache[9] || (_cache[9] = ($event: any) => ($options.updateMapSelection()))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_14), [
            [_vModelCheckbox, _ctx.selectMap]
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchText) = $event)),
            id: "dealersSearchText",
            class: "form-control",
            onChange: _cache[11] || (_cache[11] = ($event: any) => ($options.updateFilters())),
            placeholder: "Search"
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelText, _ctx.searchText]
          ]),
          _hoisted_17
        ])
      ])
    ]),
    (_ctx.selectMap == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          ($options.orderedDealers.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "No results found..."))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.orderedDealerLetters, (letter) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("p", _hoisted_21, _toDisplayString(letter), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.orderedDealers.filter(d => d.name[0].toLowerCase() == letter.toLowerCase()), (dealer) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: _normalizeClass(["dealer", [{ 'is-diamond': dealer.isdiamond }, { 'is-top-five': dealer.istopfive }]])
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => ($options.showDealer(dealer.dealerid)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#dealerFormModal",
                    innerHTML: dealer.name
                  }, null, 8 /* PROPS */, _hoisted_22),
                  _createTextVNode(),
                  (dealer.isdiamond)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.showClearButton == true)
      ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
          _createElementVNode("a", {
            class: "pointer",
            onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.resetFilters()))
          }, "Clear search request")
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}